module.exports = __webpack_public_path__ + "static/media/codepen.7c3c092b.svg";